if (!customElements.get('coast-video-reel-modal')) {
  customElements.define(
    'coast-video-reel-modal',
    class CoastVideoReelModal extends ModalDialog {
      show(opener) {
        super.show(opener);
        const targetId = opener.getAttribute('data-media-id');
        this.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.toggle('active', el.getAttribute('data-media-id') === targetId);
        });
        const activeMedia = this.querySelector(`[data-media-id="${targetId}"]`);
        if (activeMedia && typeof activeMedia.loadContent === 'function') {
          activeMedia.loadContent();
        }
      }
    }
  );
}
